import { Stack, Box } from "@mui/material";
import CustomTable from "global/components/CustomTable/CustomTable";
import viewpaths from "global/constants/ViewPathConstants";
import { openWarningNotification } from "helpers/methods";
import CenteredAuthenticatedLayout from "layouts/CenteredAuthenticated/CenteredAuthenticatedLayout";
import CenteredCardLayout from "layouts/CenteredTableView/CenteredCardLayout";
import { SortingConfig } from "models/interfaces";
import { useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { groupsTableHeader } from "screens/Groups/GropsConstants";
import history from "utils/history";

const ContactCampaigns = () => {
  const location: any = useLocation();
  const [campaigns, setGampaigns] = useState<string[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState<number>();
  const [jumpToPageNumber, setJumpToPageNumber] = useState<number>(1);
  const [selected, setSelected] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sortConfig, setSortConfig] = useState<SortingConfig[]>([]);
  const [selectedDropdownValue, setSelectedDropdownValue] =
    useState<string>("all");
  const [searchParam, setSearchParam] = useState("");
  const searchTerm = useRef<any>(null);

  const queryParams = new URLSearchParams(location.search);
  let pageValue = queryParams.get("page");
  let rowPerPage = queryParams.get("rowsPerPage");

  const handlePageChange = (event: any, pageNumber: number) => {
    history.replace(
      `${viewpaths.groupsViewPath}?&page=${pageNumber}&rowsPerPage=${rowsPerPage}`
    );
    setJumpToPageNumber(pageNumber);
  };

  const handleRowsPerPage = (rowPerPage: number) => {
    setRowsPerPage(rowPerPage);
    history.replace(
      `${viewpaths.groupsViewPath}?&page=${1}&rowsPerPage=${rowPerPage}`
    );
  };

  const handleOnChangePageInput = (newPage: number, count: number) => {
    setJumpToPageNumber(newPage);
    if (newPage && newPage >= 1 && newPage <= count) {
      history.replace(
        `${viewpaths.groupsViewPath}?&page=${newPage}&rowsPerPage=${rowsPerPage}`
      );
    } else if (!newPage) {
      openWarningNotification("Please fill in the jump to page field.");
    }
  };
  const getContactCampaigns = () => {
    return (
      <Stack direction="column" spacing={2}>
        <CenteredCardLayout removeLastChildBottomPadding={true}>
          <Box>
            <CustomTable
              headers={groupsTableHeader}
              rows={campaigns}
              page={pageValue ? Math.abs(parseInt(pageValue)) : 1}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleRowsPerPage}
              onPageChange={handlePageChange}
              count={count}
              jumpToPageNumber={jumpToPageNumber}
              showJumpToPageNumber={true}
              setJumpToPageNumber={setJumpToPageNumber}
              handleOnChangePageInput={handleOnChangePageInput}
              showPagination={true}
              isLoading={isLoading}
            />
          </Box>
        </CenteredCardLayout>
      </Stack>
    );
  };
  return <>{getContactCampaigns()}</>;
};

export default ContactCampaigns;
